import { createClientRegistrationServiceImpl } from './internal/clientRegistrationService/internal/ClientRegistrationServiceImpl';
import { ClientRegistrationService } from './ClientRegistrationService';
import { RenewLicenseService } from './RenewLicenseService';
import { createRenewLicenseServiceImpl } from './internal/renewLicenseService/internal/RenewLicenseServiceImpl';
import { PlatformAuthorizer } from '@quickplay/platform-authorizer';
import { playbackAuthorizationServiceImpl } from './internal/playbackAuthorizationService/internal/PlaybackAuthorizationServiceImpl';
import { PlaybackAuthorizationService } from './PlaybackAuthorizationService';
import { ContentAuthorizer } from './ContentAuthorizer';
import { createContentAuthorizer, PartnerPlatformAsset } from './internal/ContentAuthorizerImpl';
import { PlatformAsset } from './PlatformAsset';
import { ConsumptionType } from './ConsumptionType';
import { ContentAuthorizationConfiguration } from './ContentAuthorizationConfiguration';
import { ContentAuthorizationData } from './internal/playbackAuthorizationService/model/ContentAuthorizationData';
import {
  LicenseToken,
  LicenseProvider,
  KeyframeMetadata,
  Cuepoint,
  Subtitle,
  AdTechnology,
} from './internal/playbackAuthorizationService/internal/PlaybackAuthorizationResponse';
import { ClientAuthorizationToken } from './internal/clientRegistrationService/model/ClientAuthorizationToken';
import {
  PlaybackMode,
  DeliveryType,
  PlaybackAuthorizationRequestData,
} from './internal/playbackAuthorizationService/internal/PlaybackAuthorizationRequest';
import { RenewLicenseAsset } from './RenewLicenseAsset';
import { RenewLicenseRequest } from './internal/renewLicenseService/model/RenewLicenseRequest';
import { CheckRedeemAsset } from './CheckRedeemAsset';
import { createCheckRedeemServiceImpl } from './internal/checkRedeemService/internal/CheckRedeemServiceImpl';
import { CheckRedeemService } from './CheckRedeemService';
import { PartnerAuthorizationData } from './internal/partnerAuthorization/PartnerAuthorizationData';
export { deriveSpriteKeyframe } from './shared/util/SpriteKeyframeUtil';
/**
 * Creates a `createRenweLicenseService` that is used to get the latest licenseurl when overflow occurs
 * Platform API.
 *
 * @param renewLicenseEndPointUrl The API end-point used to get the lateset licenseurl
 * @param platform The PlatformAuthorizer instance required to securely communicate with the Platform API
 * @returns Renew License Service instance
 */
const createRenweLicenseService = (
  renewLicenseEndPointUrl: string,
  platform: PlatformAuthorizer,
): RenewLicenseService => {
  return createRenewLicenseServiceImpl(renewLicenseEndPointUrl, platform);
};

/**
 * Creates a `ClientRegistrationService` that manages communication with the client/device registration
 * Platform API.
 *
 * @param clientRegistrationEndPointUrl The API end-point for client/device registration Platform API
 * @param platform The PlatformAuthorizer instance required to securely communicate with the Platform API
 * @returns ClientRegistrationService instance
 */
const createClientRegistrationService = (
  clientRegistrationEndPointUrl: string,
  platform: PlatformAuthorizer,
): ClientRegistrationService => {
  return createClientRegistrationServiceImpl(clientRegistrationEndPointUrl, platform);
};

/**
 * Creates a `PlaybackAuthorizationService` that manages communication with the playback authorization
 * Platform API.
 *
 * @param playbackAuthorizationEndPointUrl The API end-point for playback authorization Platform API
 * @param platform The PlatformAuthorizer instance required to securely communicate with the Platform API
 * @returns PlaybackAuthorizationService instance
 */
const createPlaybackAuthorizationService = (
  playbackAuthorizationEndPointUrl: string,
  platform: PlatformAuthorizer,
): PlaybackAuthorizationService => {
  return playbackAuthorizationServiceImpl(playbackAuthorizationEndPointUrl, platform);
};

/**
 * Creates a `CheckRedeemService` that manages communication with the check redeem Edge API.
 * @param checkRedeemEndPointUrl The API end-point for check redeem Edge API
 * @param platform The PlatformAuthorizer instance required to securely communicate with the Edge API
 * @returns CheckRedeemService instance
 */
const createCheckRedeemService = (checkRedeemEndPointUrl: string, platform: PlatformAuthorizer): CheckRedeemService => {
  return createCheckRedeemServiceImpl(checkRedeemEndPointUrl, platform);
};

const version = '__buildVersion__';
export {
  createClientRegistrationService,
  createPlaybackAuthorizationService,
  createRenweLicenseService,
  createCheckRedeemService,
  createContentAuthorizer,
  PlaybackAuthorizationService,
  ClientRegistrationService,
  RenewLicenseService,
  RenewLicenseAsset,
  ContentAuthorizer,
  PlatformAsset,
  ContentAuthorizationData,
  ConsumptionType,
  PlaybackMode,
  DeliveryType,
  ContentAuthorizationConfiguration,
  version,
  LicenseToken,
  LicenseProvider,
  ClientAuthorizationToken,
  KeyframeMetadata,
  Cuepoint,
  Subtitle,
  PlaybackAuthorizationRequestData,
  RenewLicenseRequest,
  AdTechnology,
  CheckRedeemAsset,
  PartnerAuthorizationData,
  PartnerPlatformAsset,
};
